import { render, staticRenderFns } from "./SpeedLimit.vue?vue&type=template&id=1366dd73&"
import script from "./SpeedLimit.vue?vue&type=script&lang=ts&"
export * from "./SpeedLimit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports